import classNames from "classnames";
import { memo } from "react";

const prefix = "m-list";

const List = memo(({ elements, ...props }) => {
  const componentClass = classNames(prefix);
  
  return (
    <ul className={componentClass} {...props}>
      {elements?.map(({ content, ...props}, i) => <li {...props} key={i}>{content}</li>)}
    </ul>
  );
});

export default List;
